import axios from 'axios';
import {
  GET_PODCASTS_FILTER,
  GET_FILTERED_PODCASTS,
  CLEAR_FILTERED_PODCASTS,
  GET_PODCAST,
  GET_PODCAST_EPISODES,
  GET_PODCAST_THREAD,
  CLEAR_PODCAST_DATA,
  GET_NEW_PODCASTS,
  GET_LAST_PODCASTS,
  GET_TOP_PODCASTS,
  GET_RECOMMENDED_PODCASTS,
} from '../constants';

export const getPodcastsFilterSuccess = response => ({
  type: GET_PODCASTS_FILTER,
  response,
});

export const getPodcastsFilter = () => dispatch => (
  axios.get('/videos/podcasts/filter')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getPodcastsFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getPodcastsFilterSuccess(data));
    })
);

export const getFilteredPodcastsSuccess = response => ({
  type: GET_FILTERED_PODCASTS,
  response,
});

export const getFilteredPodcasts = (page = 1, genre = '', country = '', year = '', language = '') => dispatch => (
  axios.get(`/videos/podcasts?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== 0 && response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getFilteredPodcastsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getFilteredPodcastsSuccess(data));
    })
);

export const clearFilteredPodcasts = () => ({
  type: CLEAR_FILTERED_PODCASTS,
});


export const clearPodcastData = () => ({
  type: CLEAR_PODCAST_DATA,
});

export const getPodcastThreadSuccess = response => ({
  type: GET_PODCAST_THREAD,
  response,
});

export const getPodcastThread = id => dispatch => (
  axios.get(`/videos/media/thread/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getPodcastThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
        data.data = error.response.data;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getPodcastThreadSuccess(data));
    })
);

export const getPodcastEpisodesSuccess = response => ({
  type: GET_PODCAST_EPISODES,
  response,
});

export const getPodcastEpisodes = id => dispatch => (
  axios.get(`/videos/podcast/episodes/${id}?size=100`)
    .then((response) => {
      dispatch(getPodcastThread(response.data.data[0].id));
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getPodcastEpisodesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: (error.response && error.response.data) || [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getPodcastEpisodesSuccess(data));
    })
);

export const getPodcastSuccess = response => ({
  type: GET_PODCAST,
  response,
});

export const getPodcast = id => dispatch => (
  axios.get(`/videos/podcast/${id}`)
    .then((response) => {
      dispatch(getPodcastEpisodes(response.data.data.seasons[0].id));
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getPodcastSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getPodcastSuccess(data));
    })
);

export const getNewPodcastsSuccess = response => ({
  type: GET_NEW_PODCASTS,
  response,
});

export const getNewPodcasts = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/podcasts?order=new&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getNewPodcastsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getNewPodcastsSuccess(data));
    })
);


export const getLastPodcastsSuccess = response => ({
  type: GET_LAST_PODCASTS,
  response,
});

export const getLastPodcasts = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/podcasts?order=last&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getLastPodcastsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getLastPodcastsSuccess(data));
    })
);

export const getTopPodcastsSuccess = response => ({
  type: GET_TOP_PODCASTS,
  response,
});

export const getTopPodcasts = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/podcasts?order=top&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getTopPodcastsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTopPodcastsSuccess(data));
    })
);


export const getRecommendedPodcastsSuccess = response => ({
  type: GET_RECOMMENDED_PODCASTS,
  response,
});

export const getRecommendedPodcasts = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/podcasts?order=recommend&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getRecommendedPodcastsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getRecommendedPodcastsSuccess(data));
    })
);
